module.exports = __webpack_public_path__ + "static/news-c3c43751d5c281513432005ca2c391e8.jpg";